"use client"
import Heading from '@/components/ui/Heading'
import ArticleCard from '../article/ArticleCard'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export interface DigestItem {
  id: string;
  title: string;
  date?: string;
  imageUrl?: string | null;
  imageAlt?: string | null;
  href: string;
}

interface MoreDigestProps {
  items: DigestItem[];
}

const MoreDigest = ({ items }: MoreDigestProps) => {
  if (!items.length) return null;

  return (
    <div className='w-full'>
      <Heading className='text-accent-gold text-xl font-kode-mono font-semibold leading-normal tracking-[-1px]'>
        More to Digest
      </Heading>
      <div className='mt-7 sm:mt-10 overflow-hidden'>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={35}
          slidesPerView={1.15}
          breakpoints={{
            480: { slidesPerView: 1.4, spaceBetween: 24 },
            576: { slidesPerView: 2.2, spaceBetween: 24 },
            992: { slidesPerView: 2.8 },
            1300: { slidesPerView: 3.6 },
            1920: { slidesPerView: 4.4 },
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          speed={600}
          loop={items.length > 3}
          grabCursor={true}
        >
          {items.map((item) => (
            <SwiperSlide key={item.id} className='h-auto'>
              <ArticleCard
                title={item.title}
                date={item.date}
                imageUrl={item.imageUrl}
                imageAlt={item.imageAlt}
                href={item.href}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default MoreDigest